import { apiClient } from './client';

// ── Types ─────────────────────────────────────────────────────

export interface LoginAuditEntry {
  id: string;
  identifier: string;
  outcome: 'success' | 'failure';
  failureReason: string | null;
  userId: string | null;
  ipAddress: string;
  userAgent: string;
  city: string | null;
  country: string | null;
  countryCode: string | null;
  timestamp: string;
}

export interface LoginAuditQueryParams {
  identifier?: string;
  outcome?: 'success' | 'failure';
  userId?: string;
  startDate?: string;
  endDate?: string;
  page?: number;
  pageSize?: number;
}

export interface PaginatedLoginAuditResponse {
  data: LoginAuditEntry[];
  total: number;
  page: number;
  pageSize: number;
}

// ── Helper ────────────────────────────────────────────────────

function buildQueryString(params: Record<string, string | number | undefined>): string {
  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== '') {
      searchParams.append(key, String(value));
    }
  }
  const qs = searchParams.toString();
  return qs ? `?${qs}` : '';
}

// ── API Functions ─────────────────────────────────────────────

/**
 * Fetch paginated login audit logs with optional filters.
 * GET /login-audit
 */
export function fetchLoginAuditLogs(
  params: LoginAuditQueryParams = {},
): Promise<PaginatedLoginAuditResponse> {
  const qs = buildQueryString(params as Record<string, string | number | undefined>);
  return apiClient<PaginatedLoginAuditResponse>(`/login-audit${qs}`);
}
